import { useTranslation } from "react-i18next";

import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { ChangeEvent } from "utils/history/Event";
import { asTitle } from "utils/Utils";

import { BooleanField } from "core/field/FieldService";
import { FormFieldExpansionProps } from "core/field/form/FormFieldRow";

export type BooleanFormFieldExpansionProps = FormFieldExpansionProps & {
	field: BooleanField;
};

const BooleanFormFieldExpansion: React.FC<BooleanFormFieldExpansionProps> = (
	props: BooleanFormFieldExpansionProps
) => {
	const { t } = useTranslation();

	function handleValueChange(value: boolean) {
		const event = new ChangeEvent("/value", props.field.value, value);
		props.onChange(event);
	}

	return (
		<Grid container direction={"column"} alignItems="flex-start">
			<Grid item container alignItems="center">
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<Typography variant="subtitle2">
						{asTitle(t("default"))}
					</Typography>
				</Grid>
				<Grid item>
					<Checkbox
						id={props.field.name}
						disabled={!props.editable}
						checked={props.field.value}
						onChange={event =>
							handleValueChange(event.target.checked)
						}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default BooleanFormFieldExpansion;
